'use strict';

module.exports = {
  chain: require('./chain.json'),
  history: require('./history.json')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/eosjs-api/lib/api/v1/index.js
// module id = 220
// module chunks = 0